var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mode=Light, Style=Line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 12C4 7.59093 7.59093 4 12 4C16.4091 4 20 7.59093 20 12C20 16.4099 16.4092 20 12 20C7.59082 20 4 16.4099 4 12ZM12 2C6.48636 2 2 6.48636 2 12C2 17.5145 6.48636 22 12 22C17.5136 22 22 17.5145 22 12C22 6.48636 17.5136 2 12 2ZM7.2976 11.2648C7.6944 10.868 8.33773 10.868 8.73453 11.2648L11.0165 13.5469L16.2655 8.29761C16.6623 7.9008 17.3056 7.9008 17.7024 8.29761C18.0992 8.69443 18.0992 9.3378 17.7024 9.73462L11.735 15.7024C11.3382 16.0992 10.6948 16.0992 10.298 15.7024L7.2976 12.7018C6.9008 12.305 6.9008 11.6616 7.2976 11.2648Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon-check-filled",
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.48636 6.48636 2 12 2C17.5136 2 22 6.48636 22 12C22 17.5145 17.5136 22 12 22C6.48636 22 2 17.5145 2 12ZM7.2976 11.2648C7.6944 10.868 8.33773 10.868 8.73453 11.2648L11.0165 13.5469L16.2655 8.29761C16.6623 7.9008 17.3056 7.9008 17.7024 8.29761C18.0992 8.69443 18.0992 9.3378 17.7024 9.73462L11.735 15.7024C11.3382 16.0992 10.6948 16.0992 10.298 15.7024L7.2976 12.7018C6.9008 12.305 6.9008 11.6616 7.2976 11.2648Z",
    fill: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckRounded);
export default __webpack_public_path__ + "static/media/icon-check-rounded.826d9404.svg";
export { ForwardRef as ReactComponent };